// Cookout / BBQ / summer-grill stubs — outdoor entertaining,
// often crowd-feeding, often co-tagged with July 4th / Labor Day
// / Memorial Day for the summer holiday weekends.

export const COOKOUT_STUBS = [
  {
    id: "classic-cheeseburger",
    title: "Classic Cheeseburger",
    emoji: "🍔",
    blurb: "Smashed patty, American cheese, soft bun",
    discoveryTags: ["cookout", "bbq", "weeknight", "kids", "superbowl", "july4th", "memorialDay", "laborDay", "game-day", "summer-grill"],
    cuisine: "american",
    course: "main",
    mealTiming: "dinner",
    difficulty: "easy",
    estimatedTime: 25,
    keyIngredients: ["ground_beef", "cheddar", "bun"],
    buildHint: "smash technique on a hot griddle, American cheese melted on patty, simple condiments — ketchup, mustard, pickle, lettuce",
    producesCanonical: null,
  },
  {
    id: "bbq-pulled-pork",
    title: "BBQ Pulled Pork",
    emoji: "🍖",
    blurb: "Slow-cooked shoulder, smoky bark, tangy sauce",
    discoveryTags: ["cookout", "bbq", "july4th", "memorialDay", "laborDay", "game-day", "summer-grill", "comfort-food"],
    cuisine: "american",
    course: "main",
    mealTiming: "dinner",
    difficulty: "medium",
    estimatedTime: 240,
    keyIngredients: ["pork_shoulder", "bbq_sauce", "bun"],
    buildHint: "low-and-slow oven or slow cooker, dry rub bark, finished with tangy vinegar-mustard or KC-style sauce, served on potato bun with slaw",
    producesCanonical: null,
  },
  {
    id: "grilled-hot-dogs",
    title: "Grilled Hot Dogs",
    emoji: "🌭",
    blurb: "Char-grilled franks, soft bun, your favorite toppings",
    discoveryTags: ["cookout", "bbq", "kids", "july4th", "memorialDay", "laborDay", "game-day", "summer-grill", "weeknight"],
    cuisine: "american",
    course: "main",
    mealTiming: "dinner",
    difficulty: "easy",
    estimatedTime: 15,
    keyIngredients: ["hot_dogs", "bun"],
    buildHint: "grill over medium-high to crisp casing, optional split lengthwise for more char, toppings bar — mustard, ketchup, relish, onions, sauerkraut, cheese",
    producesCanonical: null,
  },
  {
    id: "bbq-baby-back-ribs",
    title: "BBQ Baby Back Ribs",
    emoji: "🍖",
    blurb: "Fall-off-the-bone ribs with sticky glaze",
    discoveryTags: ["cookout", "bbq", "july4th", "memorialDay", "laborDay", "summer-grill", "comfort-food"],
    cuisine: "american",
    course: "main",
    mealTiming: "dinner",
    difficulty: "medium",
    estimatedTime: 210,
    keyIngredients: ["pork_ribs", "bbq_sauce", "brown_sugar"],
    buildHint: "remove membrane, dry rub, slow oven 250F covered, finish with sticky glaze under broiler or grill for sear",
    producesCanonical: null,
  },
  {
    id: "grilled-corn-on-cob",
    title: "Grilled Corn on the Cob",
    emoji: "🌽",
    blurb: "Char-kissed corn with butter and salt",
    discoveryTags: ["cookout", "bbq", "kids", "july4th", "memorialDay", "laborDay", "summer-grill"],
    cuisine: "american",
    course: "side",
    mealTiming: "dinner",
    difficulty: "easy",
    estimatedTime: 20,
    keyIngredients: ["corn", "butter"],
    buildHint: "grill in husk for steamed sweetness or husked direct for char, finish with butter, salt, optional cotija and lime for elote",
    producesCanonical: null,
  },
  {
    id: "smashburger-stack",
    title: "Double Smashburger",
    emoji: "🍔",
    blurb: "Two thin patties, lacy edges, secret sauce",
    discoveryTags: ["cookout", "bbq", "weeknight", "game-day", "date-night", "summer-grill"],
    cuisine: "american",
    course: "main",
    mealTiming: "dinner",
    difficulty: "easy",
    estimatedTime: 25,
    keyIngredients: ["ground_beef", "cheddar", "bun", "mayonnaise"],
    buildHint: "smash technique critical — press hard for crispy crust, two thin patties with cheese between, secret sauce of mayo + ketchup + pickle relish",
    producesCanonical: null,
  },
];
